import ApiService from './api.service';

const SurveyService = {
    //
    getQuestions: (tagId) => {
        console.log('Requesting questions for tag ID:', tagId);
        return ApiService.fetch(`survey/questions${tagId ? `?tag_id=${tagId}` : ''}`);
      },
    //
    submitSurvey: (responses) => 
        ApiService.fetch('survey/submit', {
          method: 'POST',
          body: JSON.stringify({ responses })
        }),
    //
    checkUserSurvey: (userId) => ApiService.fetch(`survey/check/${userId}`),
    //
    getUserResponses: (userId) => ApiService.fetch(`survey/responses/${userId}`),
    //
    getAllQuestions: (tagId = null) => {
        // Se c'è un tagId, lo aggiungiamo come query parameter
        const url = tagId 
            ? `survey/questions/all?tag_id=${tagId}`
            : 'survey/questions/all';
        return ApiService.fetch(url);
    },

    //
    getQuestionById: (id) => ApiService.fetch(`survey/questions/${id}`),

    //
    createQuestion: (data) => ApiService.fetch('survey/questions', {
        method: 'POST',
        body: JSON.stringify(data)
    }),
    //
    updateQuestion: (questionId, data) => ApiService.fetch(`survey/questions/${questionId}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    }),
    //
    deleteUserResponses: (userId) => ApiService.fetch(`survey/responses/${userId}`, {
        method: 'DELETE'
    }),
    //
    deleteQuestion: (id) => ApiService.fetch(`survey/questions/${id}`, {
        method: 'DELETE'
    })

};

export default SurveyService;


